/** Maximum cumulative referral commission a leader earns per (follower, client), in USD. */
export const SQUAD_COMMISSION_CAP_USD = 200;
